const common = {
  start: "Start",
  error: "Error",
  warning: "Warning",
  success: "Success",
  info: "Info",
  loading: "Loading",
  cancel: "Cancel",
  update: "Update",
  save: "Save",
  share: "Share",
  edit: "Edit",
  preview: "Preview",
  create: "Create",
  delete: "Delete",
  add: "Add",
  apply: "Apply",
  close: "Close",
  next: "Next",
  previous: "Previous",
  finish: "Finish",
  back: "Back",
  done: "Done",
  ok: "OK",
  confirm: "Confirm",
  continue: "Continue",
  explore: "Explore",
  accept: "Accept",
  reject: "Reject",
  submit: "Submit",
  select: "Select",
  search: "Search",
  filter: "Filter",
  clear: "Clear",
  reset: "Reset",
  refresh: "Refresh",
  retry: "Retry",
  download: "Download",
  downloading: "Downloading",
  upload: "Upload",
  copy: "Copy",
  paste: "Paste",
  cut: "Cut",
  undo: "Undo",
  redo: "Redo",
  yes: "Yes",
  no: "No",
  enable: "Enable",
  disable: "Disable",
  show: "Show",
  hide: "Hide",
  expand: "Expand",
  collapse: "Collapse",
  minimize: "Minimize",
  maximize: "Maximize",
  restore: "Restore",
  lock: "Lock",
  unlock: "Unlock",
  open: "Open",
  "no-data": "No data available",
  "init.timeout.title": "Unable to connect",
  "init.timeout.message": "The connection timed out. Please check your network and try again.",
  max: "Max",
  available: "Available",
  expired: "Expired",
  "currently-unavailable": "Currently Unavailable",
  "not-available": "Not Available",
  published: "Published",
  "not-published": "Not Published",
  version: "Version",
  "sign-out": "Sign Out",
  "select-plan": "Purchase Subscription",
  play: "Play",
  skip: "Skip",
};

const domain = {
  "be-your-best": "Be Your Best",
  "session.label": "Session",
  "sessions.label": "Sessions",
  "scenario.label": "Scenario",
  "scenarios.label": "Scenarios",
  "training.label": "Training",
  "challenge.label": "Challenge",
  "challenges.label": "Challenges",
  "match.label": "Match",
  "matches.label": "Matches",
  "game.label": "Game",
  "games.label": "Games",
  "drill.label": "Drill",
  "drills.label": "Drills",

  "career.label": "Career",

  "league.label": "League",
  "leagues.label": "Leagues",
  "league.specific": "{{ league }} League",
  "league.bootcamp.name": "Bootcamp",
  "league.bootcamp.short": "Bootcamp",
  "league.bronze.name": "Bronze League",
  "league.bronze.short": "Bronze",
  "league.silver.name": "Silver League",
  "league.silver.short": "Silver",
  "league.gold.name": "Gold League",
  "league.gold.short": "Gold",
  "league.champions.name": "Champions League",
  "league.champions.short": "Champions",

  "division.label": "Division",
  "divisions.label": "Divisions",
  "division.specific": "Division {{ division }}",
  "bybiq.label": "BYB IQ",
  "rating.label": "Rating",
  "rating-points.label": "Rating Points",
  "comparison.label": "Comparison",

  "position.label": "Position",
  "position.player": "Player",
  "position.players": "Players",
  "position.unknown": "No Position",
  "position.overall": "Your overall score",
  "position.goalkeeper": "Goalkeeper",
  "position.left_fullback": "Left Fullback",
  "position.center_back": "Center Back",
  "position.right_center_back": "Right Center Back",
  "position.left_center_back": "Left Center Back",
  "position.right_fullback": "Right Fullback",
  "position.center_midfielder": "Center Midfield",
  "position.left_center_midfielder": "Left Center Midfield",
  "position.right_center_midfielder": "Right Center Midfield",
  "position.defensive_midfielder": "Defensive Midfield",
  "position.attacking_midfielder": "Attacking Midfield",
  "position.striker": "Striker",
  "position.left_winger": "Left Wing",
  "position.right_winger": "Right Wing",

  "position.short.goalkeeper": "GK",
  "position.short.left_fullback": "LB",
  "position.short.center_back": "CB",
  "position.short.right_center_back": "RCB",
  "position.short.left_center_back": "LCB",
  "position.short.right_fullback": "RB",
  "position.short.center_midfielder": "CM",
  "position.short.left_center_midfielder": "LCM",
  "position.short.right_center_midfielder": "RCM",
  "position.short.defensive_midfielder": "DM",
  "position.short.attacking_midfielder": "AM",
  "position.short.striker": "ST",
  "position.short.left_winger": "LW",
  "position.short.right_winger": "RW",

  "position.defensive": "Defensive",
  "position.midfield": "Midfield",
  "position.forward": "Forward",

  "phase.attacking": "Attacking",
  "phase.build_up": "Build-up",
  "phase.counter_attack": "Counter Attack",

  "session-type.playlist_session": "Playlist",
  "session-type.progression_session": "Career",
  "session-type.practise_session": "Practice",
  "session-type.challenge_session": "Challenge",
  "session-type.private_session": "Private Training",
  "session-type.matchplay_session": "Match Play",
};

const metrics = {
  "metric.all.name": "All metrics",
  "metric.all.long": "%",
  "metric.all.short": "%",

  "metric.awareness.name": "Awareness",
  "metric.awareness.name.initials": "A",
  "metric.awareness.long": "%",
  "metric.awareness.short": "%",

  "metric.decision.name": "Decision",
  "metric.decision.name.initials": "D",
  "metric.decision.long": "%",
  "metric.decision.short": "%",

  "metric.critical_scan.name": "Critical Scan",
  "metric.critical_scan.name.initials": "CS",
  "metric.critical_scan.long": "CS/R",
  "metric.critical_scan.short": "CS/R",

  "metric.scan_timing.name": "Scan Timing",
  "metric.scan_timing.name.initials": "ST",
  "metric.scan_timing.long": "%",
  "metric.scan_timing.short": "%",

  "metric.scan_frequency.name": "Scan Rate",
  "metric.scan_frequency.name.initials": "SR",
  "metric.scan_frequency.long": "scans/s",
  "metric.scan_frequency.short": "scans/s",

  "metric.byb_iq.name": "BYB IQ",
  "metric.byb_iq.long": "BYB IQ",
  "metric.byb_iq.short": "",
  "metric.byb_iq": "BYB IQ",

  "metric.gameplay_duration.name": "Gameplay Duration",
  "metric.gameplay_duration.minutes.long": "min(s)",
  "metric.gameplay_duration.minutes.short": "min(s)",
  "metric.gameplay_duration.seconds.long": "sec(s)",
  "metric.gameplay_duration.seconds.short": "sec(s)",

  "metric.passes_score.name": "Decision",
  "metric.passes_score.long": "%",
  "metric.passes_score.short": "%",

  "metric.scan_rate.name": "Scan Rate",
  "metric.scan_rate.long": "scans/s",
  "metric.scan_rate.short": "scans/s",

  "metric.critical_scan_score.name": "Critical Scan",
  "metric.critical_scan_score.long": "CS/R",
  "metric.critical_scan_score.short": "CS/R",

  "metric.awareness_score.name": "Awareness",
  "metric.awareness_score.long": "%",
  "metric.awareness_score.short": "%",

  "metric.total_score.name": "Total Score",
  "metric.total_score.long": "%",
  "metric.total_score.short": "%",

  "metric.score.name": "Score",
  "metric.score.long": "%",
  "metric.score.short": "%",
};

const stats = {
  "stats.activity.label": "Activity",
  "stats.activity.subtitle": "Minutes",
  "stats.training.label": "Training",
  "stats.training.subtitle": "Sessions",
  "stats.weekly_training.label": "Weekly training goal",
  "stats.weekly_training.subtitle": "Minutes",
};

const performance = {
  "performance.label.excellent": "Excellent",
  "performance.label.great": "Great",
  "performance.label.good": "Good",
  "performance.label.average": "Average",
  "performance.label.below_average": "Below Average",
  "performance.label.strong": "Strong",
  "performance.label.fair": "Fair",
  "performance.label.poor": "Poor",
  "performance.label.building": "Building",
  "performance.label.learning": "Learning",
};

const time = {
  second: "sec",
  seconds: "secs",
  minute: "min",
  minutes: "minutes",
  min: "min",
  mins: "mins",
  hour: "hr",
  hours: "hrs",
  day: "day",
  days: "days",
  week: "week",
  weeks: "weeks",
  month: "month",
  months: "months",
  year: "year",
  years: "years",

  "week-short": "w",
  "hours-short": "hrs",
  "minutes-short": "mins",
  "seconds-short": "secs",

  "minutes-extra-short": "m",
  "seconds-extra-short": "s",
  "hours-extra-short": "h",
  "days-extra-short": "d",
  "weeks-extra-short": "w",
  "months-extra-short": "m",
  "years-extra-short": "y",

  "minutes-extra-short-capitalized": "M",
  "seconds-extra-short-capitalized": "S",
  "hours-extra-short-capitalized": "H",

  "period.daily": "Daily",
  "period.weekly": "Weekly",
  "period.monthly": "Monthly",
  "period.quarterly": "Quarterly",
  "period.yearly": "Yearly",
  "period.all_time": "All Time",
};

const date = {
  "month.number.1": "Jan",
  "month.number.2": "Feb",
  "month.number.3": "Mar",
  "month.number.4": "Apr",
  "month.number.5": "May",
  "month.number.6": "Jun",
  "month.number.7": "Jul",
  "month.number.8": "Aug",
  "month.number.9": "Sep",
  "month.number.10": "Oct",
  "month.number.11": "Nov",
  "month.number.12": "Dec",

};

const gender = {
  "gender.label": "Gender",
  "gender.male": "Male",
  "gender.female": "Female",
  "gender.na": "N/A",
};

const filters = {
  "filter-by.label": "Filter by",
  "filter-by.metric.label": "Filter",
  "filter-by.period.label": "Filter by period",
  "filter-by.period.short": "Period",
  "filter-by.location.short": "Location",
  "filter-by.age.short": "Age",
  "filter-by.result.label": "Filter by result",
};

const ordinals = {
  "ordinal.1": "st",
  "ordinal.2": "nd",
  "ordinal.3": "rd",
  "ordinal.default": "th",
  "ordinal.11": "th",
  "ordinal.12": "th",
  "ordinal.13": "th",
};

export const dictionary = {
  ...common,
  ...domain,
  ...metrics,
  ...stats,
  ...time,
  ...date,
  ...gender,
  ...performance,
  ...filters,
  ...ordinals,
};
